import React, { useState } from "react";
import { CollectionServerUser, IActionHandler } from "@preveil-api";
import { useAppDispatch, useAppSelector } from "src/common";
import { ListView, Toolbar } from ".";
import { adminActions } from "src/store";
import { RootState } from "src/store/configureStore";
import _ from "lodash";

type AllProps = {
    org_users: CollectionServerUser[];
}

// Description: This component is used to render the list of users in the data export get started page
function UsersCollapseComponent(props: AllProps) {
    const { org_users } = props;
    const dispatch = useAppDispatch();
    const selected = useAppSelector((state: RootState) => state.admin.selected);
    const [filter_param, setFilterParam] = useState<string>("");
    const [filtered_list, setFilteredList] = useState<CollectionServerUser[]>(org_users);

    const UsersCollapseRequest = {
        handleSelect: (params: { user?: CollectionServerUser, selected: boolean; }) => {
            let new_selected = selected.slice();
            const _id = !!params.user ? params.user.user_id : null;
            if (!!_id) { // Note: individual check
                if (params.selected) {
                    !_.find(new_selected, (_selected: string) => (_selected === _id)) &&
                        new_selected.push(_id);
                } else {
                    const index = _.findIndex(new_selected, (_selected: string) => (_selected === _id));
                    index >= 0 && (new_selected.splice(index, 1));
                }
            } else {
                // NOTE: Filter out locked files as those entries should not be selected, deleted, etc when they are locked.
                new_selected = params.selected ? org_users.map((user: CollectionServerUser) => user.user_id) : [];
            }
            dispatch(adminActions.setSelected(new_selected));
        },
        handleSearchParam: (param?: string) => {
            if (!!param) {
                setFilterParam(param.toLowerCase());
                const filtered = org_users.filter((user: CollectionServerUser) => {
                    return Object.values(user).some(field =>
                        _.isString(field) && field.toLowerCase().includes(param.toLowerCase())
                    );
                });
                setFilteredList(filtered);
            } else {
                setFilterParam("");
                setFilteredList(org_users);
            }
        },
    };

    function handlePageActions(actionObj: IActionHandler) {
        const callback = `handle${actionObj.actionType}`;
        if ((UsersCollapseRequest as any)[callback] instanceof Function) {
            (UsersCollapseRequest as any)[callback](actionObj.params);
        }
    }
    
    return <div className="admin-component max-700 pb-0">
        <Toolbar users_list_length={org_users.length} filtered_length={filtered_list.length} filter_param={filter_param} handleAction={handlePageActions}/>
        <div id="outer-scope" className="cover-content">
            <ListView users_list={filtered_list} handleAction={handlePageActions} />
        </div>
    </div>;
}

export default React.memo(UsersCollapseComponent);